import * as React from 'react'
import { ReactComponent as DefaultLogo } from '../../assets/images/svg_icons/parking.svg'

function SvgComponent() {
  return <DefaultLogo />
}

export default SvgComponent
